"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppLayout = void 0;
const react_1 = __importStar(require("react"));
const helpers_1 = require("../../helpers");
const AppLayout_styles_1 = require("./AppLayout.styles");
const constants_1 = require("./helpers/constants");
const Overlay_1 = require("../../Overlay");
const Spinner_1 = require("../../Spinner");
exports.AppLayout = (0, helpers_1.createUIElement)('AppLayout', (_a, ref) => {
    var { className, header, body, loading, minWidth = constants_1.APP_LAYOUT_DEFAULT_MIN_WIDTH, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["className", "header", "body", "loading", "minWidth", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'app-layout', [initialDataSelectorId]);
    return (react_1.default.createElement(AppLayout_styles_1.StyledAppLayout, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": dataSelectorId, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-AppLayout', className) }),
        header && (react_1.default.createElement(AppLayout_styles_1.StyledAppLayoutHeaderSection, { "data-selector-id": 'app-layout-header', minWidth: minWidth }, header)),
        react_1.default.createElement(AppLayout_styles_1.StyledAppLayoutBodySection, { "data-selector-id": 'app-layout-body-container', minWidth: minWidth, hasHeader: !!header },
            body,
            loading && (react_1.default.createElement(Overlay_1.Overlay, { contentMod: Overlay_1.OVERLAY_CONTENT_MOD.center, view: Overlay_1.OVERLAY_VIEW.soft, "data-selector-id": "app-layout-overlay" },
                react_1.default.createElement(Spinner_1.Spinner, { size: 48, "data-selector-id": "app-layout-spinner" }))))));
});
//# sourceMappingURL=AppLayout.js.map